import { useStores } from '@littlebird/sdk';
import { useQuery } from '@tanstack/react-query';

import { userStore } from '@/stores/user.store';

export const useExpandedRoutineLibraryQuery = () => {
  const { routines } = useStores();
  return useQuery({
    queryKey: ['routine-library', userStore.user?.id, 'expanded'],
    queryFn: () => routines.fetchExpandedRoutineLibrary(),
    staleTime: 0,
  });
};
